import { render, staticRenderFns } from "./historial.vue?vue&type=template&id=d991c0c4&scoped=true"
import script from "./historial.vue?vue&type=script&lang=js"
export * from "./historial.vue?vue&type=script&lang=js"
import style0 from "./historial.vue?vue&type=style&index=0&id=d991c0c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d991c0c4",
  null
  
)

export default component.exports